import React, { Fragment, useEffect, useState } from "react";
import { Text, View } from "react-native";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "../utils/convex-api";
import { Id } from "@teachloop/backend/_generated/dataModel";
import { Button } from "../ui/button";
import { useRouter } from "expo-router";
import LessonHistoryItem from "./lesson-history-item";
import ChildrenTabList from "../shared/children-tab-list";
import ParentLessonHistorySubjectList from "./parent-lesson-history-subject-list";

function ParentLessonHistoryHome() {
  const { data: childrenData } = useQuery(
    convexQuery(api.parent.home.queries.children, {})
  );
  const children = childrenData ?? [];
  const [firstChild] = children;
  const firstChildId = firstChild?._id;
  const [selectedChildId, setSelectedChildId] = useState<Id<"students"> | null>(
    null
  );
  const { data: lessonHistorySubjectsData } = useQuery(
    convexQuery(
      api.parent.home.queries.getLessonReportSubjects,
      selectedChildId
        ? {
            studentId: selectedChildId,
          }
        : "skip"
    )
  );
  const lessonHistorySubjects = lessonHistorySubjectsData ?? [];
  const [firstSubject] = lessonHistorySubjects;
  const firstSubjectId = firstSubject?.id;
  const [selectedSubjectId, setSelectedSubjectId] =
    useState<Id<"subjects"> | null>(null);
  const { data: lessonReportsData } = useQuery(
    convexQuery(
      api.parent.home.queries.getLessonReports,
      !!selectedSubjectId && !!selectedChildId
        ? {
            subjectId: selectedSubjectId,
            studentId: selectedChildId,
            limit: 5,
          }
        : "skip"
    )
  );
  const lessonReports = lessonReportsData ?? [];
  const router = useRouter();

  useEffect(() => {
    if (firstChildId && !selectedChildId) {
      setSelectedChildId(firstChildId);
    }
  }, [firstChildId, selectedChildId]);

  useEffect(() => {
    if (firstSubjectId && !selectedSubjectId) {
      setSelectedSubjectId(firstSubjectId);
    }
  }, [firstSubjectId, selectedSubjectId]);

  return (
    <View className="gap-4 mt-4">
      <Text className="font-geologica-medium font-medium text-[20px] text-gray-800 leading-[1.5]">
        Lesson history
      </Text>
      <ChildrenTabList
        childList={children}
        selectedChildId={selectedChildId}
        setSelectedChildId={setSelectedChildId}
      />
      <ParentLessonHistorySubjectList
        lessonHistorySubjects={lessonHistorySubjects}
        selectedSubjectId={selectedSubjectId}
        setSelectedSubjectId={setSelectedSubjectId}
      />
      <View>
        {lessonReports.length === 0 && (
          <View className="px-4 py-10 bg-teachLoop-creamDark rounded-2xl">
            <Text className="font-geologica-regular text-center text-base text-gray-800 leading-[1.5]">
              Your child has no lesson history yet.
            </Text>
          </View>
        )}
        {lessonReports.slice(0, 3).map((item) => (
          <Fragment key={item._id}>
            <LessonHistoryItem item={item} />
            <View className="h-[1px] bg-gray-200" />
          </Fragment>
        ))}
      </View>
      <View className="items-end">
        {lessonReports.length > 3 && (
          <Button
            size="sm"
            outline
            className="border"
            onPress={() => {
              router.push("/(app)/lesson-history");
            }}
          >
            <Button.Text size="sm" intent="primary">
              See full history
            </Button.Text>
          </Button>
        )}
      </View>
    </View>
  );
}

export default ParentLessonHistoryHome;
